import * as Common from '@/tenant/common';

export class SupplementCommodityReportQuery extends Common.ReportQuery {
    constructor(){
        super("SupplementCommodityReportQuery", null);
    }
    public baseDate: Date = new Date().getCalendarDate();
    public isStockCommodity: boolean = true;
    public isMinimumStockQuantity: boolean = true;
    public isShortage: boolean = true;
    public onExcelExport:boolean = false;           
}

export class SupplementCommodityReportTemplateQuery extends Common.ReportTemplateQuery {
  queryName ='SupplementCommodityReportQuery';
  sort = 'id';
  constructor() {
    super();
  }
}